import React, { useEffect, useRef, useState } from 'react';
import { AccessibilityInfo, Animated, StyleSheet, View } from './rn';

// 9.20.7 — "yazıyor" baloncuğundaki üç nokta sırayla belirip söner. Önceden
// durağan bir "···" yazısıydı. Cihazda "hareketi azalt" açıksa noktalar durur.
const STEP_MS = 400;
const DIM = 0.3;
const STILL = 0.6;

type Props = {
  color: string;
  accessibilityLabel: string;
  size?: number;
};

export default function TypingDots({ color, accessibilityLabel, size = 7 }: Props) {
  const dots = useRef([0, 1, 2].map(() => new Animated.Value(STILL))).current;
  // Ayar okunana kadar null: hareket, açıkça kapalı olduğu bilinmeden başlamaz.
  const [reduceMotion, setReduceMotion] = useState<boolean | null>(null);

  useEffect(() => {
    let active = true;
    AccessibilityInfo.isReduceMotionEnabled()
      .then((on) => { if (active) setReduceMotion(on); })
      .catch(() => {});
    const subscription = AccessibilityInfo.addEventListener('reduceMotionChanged', setReduceMotion);
    return () => {
      active = false;
      subscription.remove();
    };
  }, []);

  useEffect(() => {
    if (reduceMotion !== false) {
      dots.forEach((dot) => dot.setValue(STILL));
      return undefined;
    }
    const wave = Animated.loop(Animated.stagger(STEP_MS / 2, dots.map((dot) => Animated.sequence([
      Animated.timing(dot, { toValue: 1, duration: STEP_MS, useNativeDriver: true }),
      Animated.timing(dot, { toValue: DIM, duration: STEP_MS, useNativeDriver: true }),
    ]))));
    wave.start();
    return () => wave.stop();
  }, [dots, reduceMotion]);

  return (
    <View
      style={[styles.row, { height: size * 3 }]}
      accessible
      accessibilityRole="text"
      accessibilityLabel={accessibilityLabel}
      testID="typing-dots">
      {dots.map((opacity, index) => (
        <Animated.View
          key={index}
          style={{ width: size, height: size, borderRadius: size / 2, backgroundColor: color, opacity }}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: 4 },
});
